import Icon from "@mdi/react";
import { xor } from "lodash";
import Modal from "react-responsive-modal";
import { mdiAccountEdit, mdiAccountTie, mdiPen, mdiPlus, mdiTablePicnic, mdiTruckCargoContainer } from "@mdi/js";
import { useEffect, useState } from "react";

import { useUser } from "../User";
import { api, useApi } from "../services/api";
import { Header, Remove } from "../components";

import Footer from "../components/Footer";

import { _ID, User } from "../../types";
import { useHead } from "../services/common";

export default function Mayors() {
    const { user, isAdmin, isMayor, setUser } = useUser();

    useHead(
        "Starosta | Administrace",
        "Admnistrace pro Jilemnicko - společenství obcí"
    );

    const [mail, setMail] = useState("");
    const [password, setPassword] = useState("");

    const [message, setMessage] = useState("");

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.get("logout")) {
            const redirectParam = searchParams.get("redirect");
            if (redirectParam) {
                window.location.href = redirectParam;
            } else {
                searchParams.delete("logout");
                const newSearch = searchParams.toString();
                const newPath = window.location.pathname + (newSearch ? "?" + newSearch : "");
                window.history.replaceState({}, document.title, newPath);
            }
        }
    }, []);

    useEffect(() => {
        if (user) {
            const searchParams = new URLSearchParams(window.location.search);
            const redirectParam = searchParams.get("redirect");
            if (redirectParam) {
                try {
                    const redirectUrl = new URL(redirectParam, window.location.origin);
                    redirectUrl.searchParams.set("loginToken", user.token);
                    window.location.href = redirectUrl.toString();
                } catch (e) {
                    console.error("Invalid redirect URL:", redirectParam, e);
                }
            }
        }
    }, [user]);

    return (
        <>
            <main>
                <Header
                    background="dokumenty"
                    title={user === null ? "Přihlášení" : isAdmin ? "Administrace" : "Starosta"}
                />
                <div className="content-page">
                    {user === null && <>
                        <h1>Přihlášení</h1>
                        <form
                            onSubmit={async (e) => {
                                e.preventDefault();

                                if (!password) {
                                    setMessage("Heslo je prázdné");
                                    return;
                                }

                                if (!mail) {
                                    setMessage("E-mail je prázdný");
                                    return;
                                }

                                if (password.length < 6) {
                                    setMessage("Heslo je příliš krátké");
                                    return;
                                }

                                if (!mail.includes("@")) {
                                    setMessage("Zadaný e-mail je neplatný");
                                    return;
                                }

                                setMessage("Probíhá přihlašování...");
                                const [user] = await api.addLogin({
                                    mail,
                                    password,
                                });

                                if (user) {
                                    console.log(user);
                                    setUser(user);
                                    setMessage(
                                        "Přihlášení proběhlo úspěšně",
                                    );
                                } else {
                                    setMessage("Přihlášení selhalo");
                                    return;
                                }
                            }}
                        >
                            <input
                                type="email"
                                placeholder="E-mail"
                                value={mail}
                                onChange={(e) => setMail(e.target.value)}
                            />

                            <input
                                type="password"
                                placeholder="Heslo"
                                value={password}
                                onChange={(e) =>
                                    setPassword(e.target.value)}
                            />

                            {message && <p className="alert">{message}</p>}

                            <input
                                type="submit"
                                value="Přihlásit se"
                                disabled={!mail || !password}
                            />
                        </form>
                    </>}

                    {user && <>
                        <div className="user main">
                            <Icon path={isAdmin ? mdiAccountEdit : mdiAccountTie} size={5} />
                            <h2>{user.name}</h2>
                            <p>{user.mail}</p>
                            <p>
                                {isAdmin && <b>Administrátor webu</b>}
                                {isAdmin && isMayor && " a "}
                                {isMayor && <b>Starosta</b>}
                            </p>
                        </div>


                        {message && <p className="alert">{message}</p>}

                        {!isAdmin && !isMayor && <p className="alert">Nemáš žádná práva 🙁</p>}

                        {isMayor && (
                            <>
                                <h2>Starosta</h2>
                                <div className="list slim">
                                    {user.vybaveniAccess !== false && (
                                        <div className="item page">
                                            <a
                                                className="button"
                                                href={`https://vybaveni.jilemnicko-so.cz/?loginToken=${user.token}`}
                                                target="_blank" rel="noreferrer">
                                                <Icon path={mdiTablePicnic} size={1} style={{ marginRight: "12px" }} />
                                                Rezervační systém vybavení
                                            </a>
                                        </div>
                                    )}
                                    {user.kontejnerAccess !== false && (
                                        <div className="item page">
                                            <a
                                                className="button"
                                                href={`https://kontejner.jilemnicko-so.cz/?loginToken=${user.token}`}
                                                target="_blank" rel="noreferrer">
                                                <Icon path={mdiTruckCargoContainer} size={1} style={{ marginRight: "12px" }} />
                                                Rezervační systém vývozu kontejnerů
                                            </a>
                                        </div>
                                    )}
                                </div>
                                <div style={{ height: "100px" }} />
                            </>
                        )}

                        {isAdmin && <Administration />}
                    </>}
                </div>
            </main>
            <Footer />
        </>
    );
}

function Administration() {
    const { user } = useUser();
    const [users, error, loading, , reload] = useApi.getUsers({});

    const [editUser, setEditUser] = useState<null | Omit<_ID<User>, "password">>(null);

    function handleNewUser() {
        setEditUser({
            _id: "",
            name: "",
            mail: "",
            roles: [],
        });
    }

    async function handleSave(user: _ID<User>): Promise<string> {
        if (user.name.length < 4) return "Jméno je příliš krátké";
        if (!user.mail.includes("@")) return "E-mail je neplatný";

        if (user._id === "") {
            // new user
            if (user.password.length < 6) return "Heslo je příliš krátké";

            const [id] = await api.addUser(user);

            if (id) {
                reload();
                setEditUser(null);
                return "Uživatel přidán";
            } else {
                return "Přidání uživatele selhalo";
            }
        } else {
            const [, error] = await api.updateUser(user);

            if (error) {
                return "Upravit uživatele selhalo";
            } else {
                reload();
                return "Uživatel upraven";
            }
        }
    }

    async function handleRemove(userId: string) {
        const [, error] = await api.removeUser({ userId });

        if (error) {
            return "Smazání uživatele selhalo";
        } else {
            reload();
            setEditUser(null);
            return "Uživatel smazán";
        }
    }

    return (
        <>
            <h2>
                Administrace uživatelů
                <span style={{ marginLeft: "20px" }} className="ticket clickable" onClick={handleNewUser}>
                    <Icon path={mdiPlus} size={1} /> Přidat uživatele
                </span>
            </h2>

            {user && (
                <div style={{ display: "flex", gap: "16px", marginBottom: "32px", marginTop: "16px" }}>
                    <a
                        className="button"
                        href="/"
                        style={{ padding: "10px 20px", display: "inline-flex", alignItems: "center", gap: "8px" }}
                    >
                        Administrovat jilemnicko-so.cz
                    </a>
                    <a
                        className="button"
                        href={`${window.location.hostname === "localhost" ? "http://localhost:1235" : "https://tsokrkonose.cz"}/?loginToken=${user.token}`}
                        style={{ padding: "10px 20px", display: "inline-flex", alignItems: "center", gap: "8px" }}
                    >
                        Administrovat tsokrkonose.cz
                    </a>
                </div>
            )}

            <EditUser
                user={editUser}
                onSave={handleSave}
                onRemove={handleRemove}
                onClose={() => setEditUser(null)}
            />

            {loading && <p className="alert">Načítání dat...</p>}
            {error && <p className="alert">{error}</p>}
            {users && (
                <div className="list slim">
                    {users.map((user) => (
                        <div key={user._id} className="item">
                            <div className="user grow">
                                <Icon path={user.roles.includes("admin") ? mdiAccountEdit : mdiAccountTie} size={5} />
                                <h2>{user.name}</h2>
                                <p>{user.mail}</p>
                                <p>
                                    {user.roles.includes("admin") && <b>Administrátor webu</b>}
                                    {user.roles.length > 1 && " a "}
                                    {user.roles.includes("mayor") && <b>Starosta</b>}
                                </p>
                                {user.roles.includes("mayor") && (
                                    <div style={{ marginTop: "8px" }}>
                                        {user.vybaveniAccess !== false && (
                                            <span className="ticket" style={{ backgroundColor: "#0f9759", border: "1px solid #0f9759", color: "white" }}>
                                                <Icon path={mdiTablePicnic} size={0.8} /> Vybavení
                                            </span>
                                        )}
                                        {user.kontejnerAccess !== false && (
                                            <span className="ticket" style={{ backgroundColor: "#0f9759", border: "1px solid #0f9759", color: "white" }}>
                                                <Icon path={mdiTruckCargoContainer} size={0.8} /> Kontejnery
                                            </span>
                                        )}
                                        {user.vybaveniAccess === false && user.kontejnerAccess === false && (
                                            <span className="ticket empty">Bez přístupu</span>
                                        )}
                                    </div>
                                )}
                            </div>
                            <div className="admin">
                                <button onClick={() => setEditUser(user)}>
                                    <Icon path={mdiPen} size={1} /> Udělat změny
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
}

type EditUserProps = {
    user: null | (Omit<_ID<User>, "password">);
    onSave: (user: _ID<User>) => Promise<string>;
    onRemove: (userId: string) => void;
    onClose: () => void;
};

function EditUser({ user, onSave, onRemove, onClose }: EditUserProps) {
    const [editUser, setEditUser] = useState(user);
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");

    useEffect(() => {
        setEditUser(user);
        setPassword("");
        setMessage("");
    }, [user]);

    const isNewUser = editUser?._id === "";

    async function handleNewPassword() {
        if (!editUser || editUser._id === "") return;

        if (password.length < 6) {
            setMessage("Heslo je příliš krátké");
            return;
        }

        setPassword("Ukládám nové heslo...");
        const [, error] = await api.updateUserPassword({
            userId: editUser._id,
            password,
        });

        if (error) {
            setMessage("Nastavení nového hesla selhalo");
        } else {
            setMessage("Nové heslo bylo nastaveno");
            setPassword("");
        }
    }

    return (
        <Modal
            open={user !== null}
            onClose={onClose}
            center
            styles={{
                modal: { width: "500px" },
            }}
        >
            <h2>{editUser?._id ? "Upravit" : "Přidat"} uživatele</h2>

            {message && <p className="alert">{message}</p>}

            {editUser && (
                <>
                    <input
                        type="text"
                        placeholder="Jméno"
                        value={editUser.name}
                        onChange={(e) =>
                            setEditUser({ ...editUser, name: e.target.value })}
                    />
                    <input
                        type="email"
                        placeholder="E-mail"
                        value={editUser.mail}
                        onChange={(e) =>
                            setEditUser({ ...editUser, mail: e.target.value })}
                    />

                    <label>Role uživatele</label>
                    <div>
                        <span
                            className={`ticket clickable ${editUser.roles.includes("admin") ? "" : "empty"
                                }`}
                            onClick={() => {
                                setEditUser({
                                    ...editUser,
                                    roles: xor(editUser.roles, ["admin"]),
                                });
                            }}
                        >
                            <Icon path={mdiAccountEdit} size={1} />{" "}
                            Administrátor webu
                        </span>
                        <span
                            className={`ticket clickable ${editUser.roles.includes("mayor") ? "" : "empty"
                                }`}
                            onClick={() => {
                                setEditUser({
                                    ...editUser,
                                    roles: xor(editUser.roles, ["mayor"]),
                                    // Default access to true if mayor role is selected
                                    vybaveniAccess: editUser.vybaveniAccess === false ? false : true,
                                    kontejnerAccess: editUser.kontejnerAccess === false ? false : true,
                                });
                            }}
                        >
                            <Icon path={mdiAccountTie} size={1} /> Starosta
                        </span>
                    </div>

                    {editUser.roles.includes("mayor") && (
                        <>
                            <label style={{ marginTop: "16px", display: "block" }}>Přístup k rezervačním systémům</label>
                            <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "8px" }}>
                                <span
                                    className={`ticket clickable ${editUser.vybaveniAccess !== false ? "" : "empty"}`}
                                    onClick={() => {
                                        setEditUser({
                                            ...editUser,
                                            vybaveniAccess: editUser.vybaveniAccess === false ? true : false,
                                        });
                                    }}
                                    style={{ height: "auto", minHeight: "24px", padding: "6px 16px", borderRadius: "8px", display: "inline-flex" }}
                                >
                                    <Icon path={mdiTablePicnic} size={1} /> Rezervační systém vybavení
                                </span>
                                <span
                                    className={`ticket clickable ${editUser.kontejnerAccess !== false ? "" : "empty"}`}
                                    onClick={() => {
                                        setEditUser({
                                            ...editUser,
                                            kontejnerAccess: editUser.kontejnerAccess === false ? true : false,
                                        });
                                    }}
                                    style={{ height: "auto", minHeight: "24px", padding: "6px 16px", borderRadius: "8px", display: "inline-flex" }}
                                >
                                    <Icon path={mdiTruckCargoContainer} size={1} /> Rezervační systém vývozu kontejnerů
                                </span>
                            </div>
                        </>
                    )}

                    {isNewUser && (
                        <input
                            type="text"
                            placeholder="Nové heslo"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    )}

                    {!isNewUser && <div className="flex right">
                        <button
                            onClick={async () => {
                                setMessage("Ukládám...");
                                setMessage(
                                    await onSave({ ...editUser, password }),
                                );
                            }}
                        >
                            Uložit
                        </button>
                    </div>}

                    <div className="divider" />

                    {!isNewUser && <>
                        <h3 style={{ paddingTop: "32px" }}>Změnit heslo</h3>
                        <div className="flex">
                            <input
                                type="text"
                                placeholder="Nové heslo"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <button onClick={handleNewPassword}>
                                Nastavit nové heslo
                            </button>
                        </div>
                    </>}
                    {!isNewUser && <div className="divider" />}

                    <div className="buttons" style={{ marginTop: "20px" }}>
                        {!isNewUser && <Remove onRemove={() => onRemove(editUser._id)}>Smazat uživatele</Remove>}
                        {isNewUser && <button
                            onClick={async () => {
                                setMessage("Ukládám...");
                                setMessage(
                                    await onSave({ ...editUser, password }),
                                );
                            }}
                        >
                            Přidat uživatele
                        </button>}
                    </div>
                </>
            )}
        </Modal>
    );
}
